import { setButtonSpinnerState } from '../components/double-click-no-delay';
export default class LinkAccounts {
    constructor() {
        const linkAccountsPage = document.getElementById('linkAccountsPage');

        if (!linkAccountsPage) {
            return false;
        }
        else {
            this.init();
        }
    }

    init() {
        this.linkAccountsButton = document.getElementById('linkAccountsButton');
        this.verificationCode = document.getElementById('hiddenVerificationCode').value;
        this.linkAccountsErrorNotification = document.getElementById('linkAccountsErrorNotification');
        this.displayLinkAccountsErrorNotification = function (isShow, verificationError) {
            document.getElementById('linkAccountsErrorNotification').innerHTML = verificationError;
            this.linkAccountsErrorNotification.style.display = isShow ? "block" : "none";
        }
        this.displayAccountsLinkedModal = function (isShow) {
            this.accountsLinkedModal.style.display = isShow ? "block" : "none";
        }
        this.accountsLinkedModal = document.getElementById('modal-linked-accounts');
        this.init = this.init.bind(this);
        this.main();
    }

    main() {
        var self = this;

        self.linkAccountsButton.onclick = function () {
            self.displayLinkAccountsErrorNotification(false);
            setButtonSpinnerState(self.linkAccountsButton, false);

            $.ajax({
                url: "/Account/VerifyAndLinkAccounts",
                dataType: "json",
                type: "POST",
                data: {
                    'verificationCode': self.verificationCode
                },
                success: function (response) {
                    if (response.success) {
                        self.displayLinkAccountsErrorNotification(false);
                        if (response.accountsLinked) {
                            self.displayAccountsLinkedModal(true);
                            setTimeout(function () {
                                window.location.href = response.redirectToUrl;
                            }, 3000);
                        }
                        else {
                            window.location.href = response.redirectToUrl;
                        }
                    }
                    else {
                        self.displayLinkAccountsErrorNotification(true, response.verificationError);
                    }
                    setButtonSpinnerState(self.linkAccountsButton, true);
                }
            });
        };
    }
}
